import { createFetchInstance } from '../utils/fetch-instance'

export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig()
	const fetchCrmBridge = createFetchInstance(config.public.bridgeCrmUrl)

	return {
		provide: {
			fetchCrmBridge,
		},
	}
})
